// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "calendar_source".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "calendar_source" table (1:1 with a DB row, on the wire). */
export const calendarSourceAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    icalCalendarId: z.string(),
    userId: z.string(),
    name: z.string(),
    kind: z.enum(['ical', 'treatwell']),
    encryptedConfig: z.string(),
    inboundTokenHash: z.string().nullable(),
    etag: z.string().nullable(),
    lastModified: z.string().nullable(),
    lastSyncAt: z.string().datetime().nullable(),
    lastAttemptAt: z.string().datetime().nullable(),
    syncLeaseId: z.string().nullable(),
    syncLeaseUntil: z.string().datetime().nullable(),
    lastError: z.string().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=calendarSource.js.map